<template>
  <div class="media-filter-bar mb-3 p-3 bg-dark rounded d-flex align-items-center">
    <!-- LEFT: Search Input -->
    <div class="flex-grow-1 mr-3" style="max-width: 500px;">
      <!-- <template v-if="(mediaType != 'category') || searchMode"> -->
        <template v-if="searchMode">
          <b-input-group class="w-100">
            <b-form-input ref="search" v-model="searchInput" placeholder="Type to Search" size="lg" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); color: white;"/>
            <b-input-group-append>
              <div class="d-flex align-items-center px-2" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-left: none;">
                <b-button variant="link" class="p-0 text-white" :disabled="!searchInput" @click="searchInput = ''">
                  <Icon icon="Search_backspace"/>
                </b-button>
              </div>
            </b-input-group-append>
          </b-input-group>
        </template>
        <template v-else>
          <b-input-group class="w-100">
            <b-form-input ref="search" v-model="filterInput" placeholder="Filter items..." size="lg" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); color: white;"/>
            <b-input-group-append>
              <div class="d-flex align-items-center px-2" style="background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); border-left: none;">
                <b-button variant="link" class="p-0 text-white" :disabled="!filterInput" @click="filterInput = ''">
                  <Icon icon="Search_backspace"/>
                </b-button>
              </div>
            </b-input-group-append>
          </b-input-group>
        </template>
      <!-- </template> -->
    </div>

    <!-- CENTER/RIGHT: Filters -->
    <div class="d-flex align-items-center flex-wrap ml-3">
       <!-- <template v-if="(mediaType != 'category') || searchMode"> -->
        
        <span class="text-muted text-uppercase font-weight-bold small mr-3" style="letter-spacing: 1px;">Filters</span>

        <PublishStatusFilter ref="publishStatusFilter" class="mr-3"/>

        <!-- PARTNER FILTER (Dropdown) -->
        <template v-if="mediaType != 'category' && !searchMode">
          <b-dropdown variant="link" class="filter-dropdown mr-3" no-caret>
            <template slot="button-content">
              <div class="d-flex align-items-center">
                 <font-awesome-icon icon="handshake" class="mr-2"/>
                 <span class="text-truncate" style="max-width: 150px;">
                   {{ getPartnerLabel() }}
                 </span>
                 <font-awesome-icon icon="chevron-down" size="xs" class="ml-2 opacity-50"/>
              </div>
            </template>
            <b-dropdown-item @click="$store.dispatch('media/setPartner', null)" :active="$store.state.media.partnerFilter === null">
              -- Filter by Partner --
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
             <b-dropdown-item v-for="opt in $store.state.media.options.partnerFilter" :key="opt.value" 
                @click="$store.dispatch('media/setPartner', opt.value)"
                :active="$store.state.media.partnerFilter === opt.value">
                {{ opt.text }}
              </b-dropdown-item>
          </b-dropdown>
        </template>
        
        <!-- SORT ORDER (Dropdown) -->
        <b-dropdown variant="link" class="filter-dropdown mr-3" no-caret>
             <template slot="button-content">
              <div class="d-flex align-items-center">
                 <font-awesome-icon icon="sort-amount-down" class="mr-2"/>
                 <span class="text-truncate" style="max-width: 150px;">
                   {{ getSortLabel() }}
                 </span>
                 <font-awesome-icon icon="chevron-down" size="xs" class="ml-2 opacity-50"/>
              </div>
            </template>
            <b-dropdown-item v-for="opt in (mediaType == 'category' ? $store.state.media.options.categorySortOrder : $store.state.media.options.sortOrder)" 
              :key="opt.value" 
              @click="mediaType == 'category' ? $store.commit('media/putCategorySortOrder', opt.value) : $store.commit('media/putSortOrder', opt.value)"
              :active="(mediaType == 'category' ? $store.state.media.categorySortOrder : $store.state.media.sortOrder) === opt.value">
              {{ opt.text }}
            </b-dropdown-item>
        </b-dropdown>

        <MediaSearchTypeFilter v-if="$store.state.media.searchMode" ref="mediaTypeFilter"/>
        <MediaTypeFilter v-else ref="mediaTypeFilter"/>
      <!-- </template> -->
    </div>

    <!-- RIGHT: Toggle -->
    <div class="ml-auto pl-3 border-left border-secondary">
      <b-form-checkbox v-model="searchMode" name="check-button" switch size="lg">
        <span class="ml-2" style="font-size: 0.9rem; font-weight: 500;">Search Mode</span>
      </b-form-checkbox>
    </div>

  </div>
</template>

<script>
import PublishStatusFilter from './PublishStatusFilter.vue'
import MediaTypeFilter from './MediaTypeFilter.vue'
import MediaSearchTypeFilter from './MediaSearchTypeFilter.vue'

export default {
  name: "MediaFilterBar",

  components: {
    PublishStatusFilter,
    MediaTypeFilter,
    MediaSearchTypeFilter,
  },

  props: {
    mediaType: String
  },

  computed: {
    filterInput: {
      get() { return this.$store.state.media.searchFilterString},
      set(value) {
        this.$store.commit('media/updateSearchFilter', value)
      }
    },

    searchInput: {
      get() {
        if(this.mediaType == "category") {
          return this.$store.state.media.searchCategoriesString
        }
        else {
          return this.$store.state.media.searchMediaString
        }
      },
      set(value) {
        if(this.mediaType == "category") {
          this.$store.dispatch('media/searchCategories', value)
        }
        else {
          this.$store.dispatch('media/searchMedia', value)
        }

      }
    },

    searchMode: {
      get() { return this.$store.state.media.searchMode},
      set(value) {
        this.$store.dispatch('media/setSearchMode', value)
      }
    }
  },

  methods: {
    focusSearch() {
      if(this.$refs.search) {
        this.$refs.search.focus()
      }
    },

    clearSearch() {
      this.filterInput = ''
    },
    
    // Proxy methods for Bar.vue to call if it still holds references, 
    // though ideally Bar.vue shouldn't need to call these on the toolbar anymore if structure changes.
    // However, keeping them here as they were used in refs.
    
    mediaLabelMatch() {
        return true; 
    },

    getPartnerLabel() {
      const filter = this.$store.state.media.partnerFilter
      if (!filter) return 'Partner'
      const option = this.$store.state.media.options.partnerFilter.find(o => o.value === filter)
      return option ? option.text : 'Partner'
    },

    getSortLabel() {
      const isCategory = (this.mediaType == 'category')
      const options = isCategory ? this.$store.state.media.options.categorySortOrder : this.$store.state.media.options.sortOrder
      const value = isCategory ? this.$store.state.media.categorySortOrder : this.$store.state.media.sortOrder
      
      const option = options.find(o => o.value === value)
      return option ? option.text : 'Sort Order'
    }
  },

  created() {
    this.$root.$on('media-search-focus', this.focusSearch)
    this.$root.$on('media-search-clear-selection', this.clearSearch)
  },

  beforeDestroy() {
    this.$root.$off('media-search-focus', this.focusSearch)
    this.$root.$off('media-search-clear-selection', this.clearSearch)
  }
}
</script>

<style scoped>
.media-filter-bar {
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  border: 1px solid rgba(255,255,255,0.05);
}
</style>
